import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import Cookies from "js-cookie";

export default async function changePassword(status, endpoint) {
  const url = endpoint + "changePassword";
  const js = JSON.stringify(status);
  const header = {
    "Content-Type": "application/json",
  };

  try {
    const config = { method: "PUT", headers: header, body: js };
    const response = await fetch(url, config);
    const json = await response.json();

    if (json.status === true) {
      alertify.set("alert", "position", "bottom-right");
      alertify.set("notifier", "delay", 5.0);
      alertify.success("Registro Modificado");
    } else {
      if (
        json.message === "Token no válido - 403" ||
        json.message === "No connection"
      ) {
        localStorage.setItem("tkreact", null);
        document.location.href = `/?route=adm_account`;
        alertify.set("alert", "position", "bottom-right");
        alertify.set("notifier", "delay", 5.0);
        alertify.error("token invalido");
      } else {
        alertify.set("alert", "position", "bottom-right");
        alertify.set("notifier", "delay", 5.0);
        alertify.error("No fue posible modificar el elemento");
      }
    }
  } catch (error) {
    console.log("Error" + error);
    const tkreact = "tkreact_" + localStorage.getItem("instance");
    if (
      Cookies.get(tkreact) === null ||
      Cookies.get(tkreact) === undefined ||
      Cookies.get(tkreact) === "null" ||
      Cookies.get(tkreact) === "undefined"
    ) {
      localStorage.setItem("tkreact", null);
      document.location.href = `/?route=adm_account`;
    } else {
      localStorage.setItem("tkreact", null);
      document.location.href = `/?route=adm_account`;
    }
  }
}
